import React from 'react';
import { useEffect } from 'react';
import { useGlobalContext } from '../../contexts/GlobalContext';
import INAVIHomePage from './INAVIHomePage';

function INAVIHomePageContainer() {
    const { fetchSetting } = useGlobalContext();

    useEffect(() => {
        fetchSetting();
    }, []);

    return <INAVIHomePage />;
}

export default INAVIHomePageContainer;
